//  page src/services/websocketService.ts
class WebSocketService {
  private socket: WebSocket | null = null
  private reconnectTimer: ReturnType<typeof setTimeout> | null = null
  private destroyed = false
  private username = ''

  connect(username: string) {
    if (!username) return
    this.destroyed = false
    this.username = username
    this._connect()
  }

  private _connect() {
    if (this.destroyed) return
    if (this.socket?.readyState === WebSocket.OPEN) return

    const apiUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8001/api/v1'
    const wsBaseUrl = apiUrl
      .replace('http://', 'ws://')
      .replace('https://', 'wss://')
      .replace('/api/v1', '')

    const token = localStorage.getItem('access_token') || ''
    this.socket = new WebSocket(
      `${wsBaseUrl}/ws/user/${this.username}?token=${encodeURIComponent(token)}`
    )

    this.socket.onopen = () => {
      console.log('[UserWS] Connected username=' + this.username)
    }

    this.socket.onerror = () => {
      console.warn('[UserWS] Connection error')
    }

    this.socket.onclose = (e) => {
      if (this.destroyed) return
      if (e.code === 4001) {
        console.error('[UserWS] Auth failed — not reconnecting')
        return
      }
      this.reconnectTimer = setTimeout(() => this._connect(), 3000)
    }
  }

  disconnect() {
    this.destroyed = true
    if (this.reconnectTimer) clearTimeout(this.reconnectTimer)
    this.socket?.close()
    this.socket = null
  }
}

export default new WebSocketService()
